import { Box, Card, CircularProgress, IconButton, Paper, Typography } from '@mui/material'
import PDFViewer from '../controls/PDFViewer'
import { Close } from '@mui/icons-material'

interface P {
    status: string
    onClose: () => void
    pdfLink: string
}

const ReportPreview = ({ status, onClose, pdfLink }: P) => {
    return (
        <Paper
            sx={{
                height: '-webkit-fill-available',
                display: 'flex',
                flexDirection: 'column',
                padding: 2

            }}
            elevation={4}>

            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 2
            }}>
                <Typography variant='h6' fontWeight='bold'>
                    Preview
                </Typography>

                <IconButton
                    onClick={onClose}
                    sx={{
                        'backgroundColor': 'action.hover',
                        '&:hover': {
                            backgroundColor: 'action.selected'
                        }
                    }}>
                    <Close fontSize='small' />
                </IconButton>
            </Box>
            <Card style={{ flex: 1, height: '100%', width: '100%', position: 'relative' }}>
                {status === 'loading' && (
                    <Box style={{ display: 'flex', position: 'absolute', top: '50%', left: '50%' }}>
                        <CircularProgress />
                    </Box>
                )}
                <PDFViewer file={pdfLink} />
            </Card>
        </Paper>
    )
}

export default ReportPreview
